<template>
  <b-form-select
    class="form-control"
    :options="options"
    v-model="innerValue"
  />
</template>

<script>
import { BFormSelect } from "bootstrap-vue-next";

export default {
  components: {
    BFormSelect
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [String, Number, null],
      default: null
    }
  },
  emits: ["update:modelValue"],
  computed: {
    innerValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  }
}
</script>